const formatCurrency = (number, zeroText = '') => {
  if (!number && zeroText) {
    return zeroText;
  }

  return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export default formatCurrency;
